import { useNavigation } from '@react-navigation/native';
import { Headline1, Meta, Spinner, theme } from 'aimo-ui';
import CrickleCutCardBackground from 'components/common/CrickleCutCardBackground';
import ServiceContext from 'context/ServiceContext';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView } from 'react-native-gesture-handler';
import styled from 'styled-components/native';
import {
  ColumnWithMargins,
  SheetDetailsWrapper,
  StyledWrapper,
} from 'styles/ContainerStyles';
import { Maybe, ParkingSession, ParkZone } from 'types/generatedSchemaTypes';
import { ServicesNavProps } from 'types/navigation';
import { isWeb } from 'utils/deviceUtils';
import PrepaidTicketContent from './PrepaidTicketContent';

const SessionWrapper = styled.TouchableOpacity`
  margin-bottom: 20px;
`;

const AboveCutView = ({
  sessionId,
  parkZone,
  t,
}: {
  sessionId: string;
  parkZone: Maybe<ParkZone> | undefined;
  t: (key: string) => string;
}) => (
  <ColumnWithMargins mr={20} ml={20}>
    <StyledWrapper center mb={5}>
      <Headline1 center testID={`session-${sessionId}-name`}>
        {parkZone?.commercialZoneView?.name || parkZone?.name}
      </Headline1>
    </StyledWrapper>
    <StyledWrapper center>
      <Meta color={theme.colors.gray300}>{t('services.prepaidTitle')}</Meta>
    </StyledWrapper>
  </ColumnWithMargins>
);

const BelowCutView = ({
  session,
  onPress,
}: {
  session: ParkingSession;
  onPress: () => void;
}) => <PrepaidTicketContent session={session} onPress={onPress} />;

const SessionItem = ({ session }: { session: ParkingSession }) => {
  const { navigate } = useNavigation<ServicesNavProps>();
  const { t } = useTranslation();
  const { sessionId, parkZone } = session;

  const handleSelectTicket = () => {
    navigate('prepaidTicket', { ticketId: session?.sessionId });
  };

  return (
    <SessionWrapper
      onPress={handleSelectTicket}
      activeOpacity={0.65}
      testID={`session-${sessionId}-wrapper`}>
      <CrickleCutCardBackground
        aboveCutView={
          <AboveCutView sessionId={sessionId} parkZone={parkZone} t={t} />
        }
        belowCutView={
          <BelowCutView session={session} onPress={handleSelectTicket} />
        }
        backgroundColor={theme.colors.white}
        cutColor={theme.colors.gray100}
      />
    </SessionWrapper>
  );
};

const PrepaidTickets = () => {
  const { myPrepaidSessions, prepaidLoading, prepaidError } =
    useContext(ServiceContext);

  if (prepaidError) {
    return <></>;
  }

  return (
    <ScrollView>
      <SheetDetailsWrapper>
        {prepaidLoading && (
          <StyledWrapper center>
            <Spinner />
          </StyledWrapper>
        )}
        {!prepaidLoading && (
          <StyledWrapper
            center={isWeb}
            mb={10}
            maxWidth={isWeb ? 600 : undefined}>
            {myPrepaidSessions?.map((session: ParkingSession) => (
              <SessionItem session={session} key={session.sessionId} />
            ))}
          </StyledWrapper>
        )}
      </SheetDetailsWrapper>
    </ScrollView>
  );
};

export default PrepaidTickets;
